import { UPLOADED_FILE_STATUS } from "common/constants";

export const cleanDataUpdateImportStatuses = [
  { value: UPLOADED_FILE_STATUS["s4"], name: "Submission Problem" },
  { value: UPLOADED_FILE_STATUS["s5"], name: "Problems Found" },
  { value: UPLOADED_FILE_STATUS["s6"], name: "Clean Data Updated" },
];
